module.exports = __webpack_public_path__ + "static/media/close.9c184654.svg";